<div class="grid grid-cols-12 gap-4">
  <!-- Search, Filter, Clear -->
  <div class="col-span-12">
    <microsec-common-toolbar
      #ct
      [configuration]="filterConfiguration"
      [filterObject]="filterObject"
      [leftTemplate]="!!permissions[USER_ROLE.TECHNICIAN] ? leftTemplate : null">
      <ng-template #leftTemplate>
        <span
          [pTooltip]="!!checkAssessmentQuota ? (!!isValidLicense() ? '' : INACTIVE_LICENSE) : 'Maximum number of assessments reached'"
          tooltipPosition="bottom"
          appendTo="body">
          <p-button
            severity="primary"
            [label]="'Create New Assessment'"
            [rounded]="true"
            icon="pi pi-plus"
            (onClick)="openAssessmentForm()"
            [disabled]="!!isLoading || !checkAssessmentQuota || !isValidLicense()" />
        </span>
      </ng-template>
    </microsec-common-toolbar>
  </div>

  <div class="col-span-12" [ngClass]="{ 'lg:col-span-6': !!selectedAssessment }" id="tb" (click)="hideDetailsPanel($event)">
    <microsec-card [isTableCard]="true">
      <microsec-common-table
        #dt
        [lazy]="true"
        (lazyLoadEvent)="getAssessments(false, true, $event)"
        [totalRecords]="totalRecords"
        [cols]="selectedCols || []"
        [values]="values"
        [loading]="isLoading"
        selectionMode="multiple"
        [(selection)]="selectedAssessments"
        [(rowSingleSelection)]="selectedAssessment"
        [cellTemplate]="cellTemplate"
        [dataKey]="'id'"
        [noSortingCols]="['assessment_type']"
        itemName="Assessment"
        [containerHeaderRightTemplate]="containerHeaderRightTemplate">
      </microsec-common-table>
    </microsec-card>
  </div>

  <ng-template let-col="col" let-rowData="rowData" #cellTemplate>
    <ng-container [ngSwitch]="col.field">
      <!-- Type -->
      <ng-container *ngSwitchCase="'assessment_type'">
        {{ rowData[col.field]?.name || 'ID: ' + rowData.assessment_type_id || '-' }}
      </ng-container>
      <!-- Status -->
      <ng-container *ngSwitchCase="'status'">
        <span
          [ngClass]="{
            'text-green': rowData[col.field] === ASSESSMENT_STATUS.COMPLETED,
            'text-orange': rowData[col.field] === ASSESSMENT_STATUS.ACTIVE,
            'text-grey': rowData[col.field] === ASSESSMENT_STATUS.OPEN
          }">
          {{ (rowData[col.field] | constant: 'assessment-result') || '-' }}
        </span>
      </ng-container>
      <!-- Scheduled Date -->
      <ng-container *ngSwitchCase="'scheduled'">
        {{ (rowData[col.field] | momentPipe) || '-' }}
      </ng-container>
      <!-- Actions -->
      <ng-container *ngSwitchCase="'actions'">
        @if (!!permissions[USER_ROLE.READ_ONLY]) {
          <div class="w-max flex items-center gap-4" (click)="$event.stopPropagation()">
            @switch (rowData.status) {
              @case (ASSESSMENT_STATUS.COMPLETED) {
                @if (rowData.report_status === ASSESSMENT_REPORT_STATUS.COMPLETED) {
                  <!-- View Result -->
                  <p-button
                    icon="fas fa-clipboard-list"
                    label="View Result"
                    severity="success"
                    size="small"
                    [rounded]="true"
                    styleClass="text-transform-none custom-button w-36"
                    (onClick)="openAssessmentReport(rowData)" />
                } @else {
                  <!-- Processing -->
                  <p-button
                    icon="fas fa-circle-notch fa-spin"
                    label="Processing"
                    severity="success"
                    size="small"
                    [rounded]="true"
                    styleClass="text-transform-none custom-button w-36"
                    [disabled]="true" />
                }
              }
              @default {
                <!-- Start/Resume -->
                <div [pTooltip]="!isValidLicense() ? INACTIVE_LICENSE : ''" tooltipPosition="bottom" appendTo="body">
                  <p-button
                    icon="fas fa-play"
                    [label]="rowData.status === ASSESSMENT_STATUS.OPEN ? 'Start' : 'Resume'"
                    [severity]="$any(rowData.status === ASSESSMENT_STATUS.OPEN ? 'secondary' : 'warning')"
                    size="small"
                    [rounded]="true"
                    [styleClass]="'text-transform-none w-36' + (rowData.status !== ASSESSMENT_STATUS.OPEN ? ' custom-button' : '')"
                    [disabled]="!isValidLicense()"
                    (onClick)="execute(rowData)" />
                </div>
              }
            }
          </div>
        }
      </ng-container>
      <ng-container *ngSwitchDefault>
        <div class="overflow-hidden whitespace-nowrap text-ellipsis">
          {{ rowData[col.field] || '-' }}
        </div>
      </ng-container>
    </ng-container>
  </ng-template>

  @if (!!selectedAssessment) {
    <div class="col-span-12 lg:col-span-6">
      <app-assessment-details
        [isLoading]="isLoading"
        [(assessment)]="selectedAssessment"
        (hideDetailsPanelEvent)="hideDetailsPanel($event)"
        (executeEvent)="execute($event)"
        (openAssessmentFormEvent)="openAssessmentForm($event)"
        (openDeleteConfirmationEvent)="openDeleteConfirmation($event)"
        (openAssessmentReportEvent)="openAssessmentReport($event)" />
    </div>
  }
</div>

<ng-template #containerHeaderRightTemplate>
  <div class="flex flex-wrap items-center gap-2">
    <microsec-operation-button
      operation="Delete"
      buttonClass="p-button-danger"
      icon="fa fa-trash"
      (selectedOperationEvent)="openDeleteConfirmation(selectedAssessments)"
      (allOperationEvent)="openDeleteConfirmation()"
      [disabled]="!selectedAssessments.length"
      *ngIf="!!permissions[USER_ROLE.ADMIN]" />
    <microsec-refresh-button (refreshEvent)="getAssessments()" />
    <microsec-table-column-filter
      [key]="constructor.name"
      [cols]="cols"
      [(selectedColFields)]="selectedColFields"
      (exportReportEvent)="openGenerateReportDialog()" />
  </div>
</ng-template>
